import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { isInternalUrl, toInternalPath } from "../../../../Shared/utils/internalUrl";
import { Link } from "react-router-dom";
export const Button = (props)=>/*#__PURE__*/ _jsx("button", {
        className: `button${props.arrow ? " button--arrow" : ""} ${props.variant ? props.variant : ""} ${props.className ? props.className : ""}`,
        onClick: ()=>props.handle(),
        ...props.buttonProps,
        children: props.children
    });
export const LinkButton = (props)=>{
    let className = `button${props.arrow ? " button--arrow" : ""} ${props.variant ? props.variant : ""} ${props.className ? props.className : ""}`;
    let onClick = ()=>props.handle && props.handle();
    const isInternal = isInternalUrl(props.route);
    const routePath = isInternal ? toInternalPath(props.route) : props.route;
    return props.route.substr(0, 4) === "http" && !isInternal ? /*#__PURE__*/ _jsx("a", {
        className: className,
        href: props.route,
        target: "_blank",
        onClick: onClick,
        children: props.children
    }) : /*#__PURE__*/ _jsx(Link, {
        className: className,
        to: routePath,
        onClick: onClick,
        children: props.children
    });
};
